module.exports = __webpack_public_path__ + "static/media/1.3 Servatius Schild klein.137e509d.jpg";